import SceButton from './../../../Common/CommonComponents/sceButton.js';
import TimeoutDialogStyles from './sceTimeoutDialog.scss';
import TimeoutTimer from './timeoutTimer.js';
import { getLocalizedStrings } from '../../loginLocalizedStrings';

const TimeoutDialog = (props) => {
    const strings = getLocalizedStrings('loginComponent');
    return (
        <div className={TimeoutDialogStyles.timeoutDialogSection}>
            <div className={TimeoutDialogStyles.timeoutDialogText}>
                {(props.timedOut) ? 
                <div className={TimeoutDialogStyles.warningMessage}>
                    <p>{strings.inactivityWarningMessage}</p>
                    <p>{strings.inactivityWarningActionMessage}</p>
                </div>
                :
                <div>
                    <p>{strings.timedOutMessage}</p>
                    <p>
                        {strings.timedOutActionMessage}
                        <TimeoutTimer updateTimedOut={props.updateTimedOut} updateTimeoutValue={props.updateTimeoutValue} onTimeoutDialogExtend={props.onTimeoutDialogExtend} />
                    </p>
                </div>
                }
            </div>
            <div className={TimeoutDialogStyles.timeoutDialogActions}>
                <div className='pull-right'>
                    {(props.timedOut) ? 
                    <SceButton id="TimeoutDialogOk" buttonType="primary" value={strings.ok} responive="false" onClick={props.onTimeoutDialogOk} /> : 
                    <SceButton id="TimeoutDialogExtend" buttonType="primary" value={strings.extend} responive="false" onClick={props.onTimeoutDialogExtend} /> }
                </div>
                <div className='clearfix' />
            </div>
        </div>
    );
};

export default TimeoutDialog;
